import { SourceMapIdentifierPayload } from '../types'

// Every source map in this feature is a local Company ↔ source record pair, always with the same
// two `id` identifiers. Kept in one place so the payload shape can't drift between the wizard and
// the pair editor.
export const buildSourceMapIdentifiers = (localCompanyId: string, sourceId: string): SourceMapIdentifierPayload[] => [
  { key: 'id', value: localCompanyId, type: 'string', identifierType: 'local' },
  { key: 'id', value: sourceId, type: 'string', identifierType: 'source' }
]

// Display label for a picked source record: "Name · 1234567-8", or just the name when no vatId.
export const formatSourceLabel = (record: { name: string; vatId?: string }): string =>
  record.vatId ? `${record.name} · ${record.vatId}` : record.name
